import React from 'react';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { ActivityProps } from '..';
import InformationOverlay from '../../../../components/InformationOverlay';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';

import './style.scss';

const ActivityTeaser: React.FC<ActivityProps> = (props) => {
  const { entity } = props;
  const name = entity.getIn(['name', 0, 'value']);
  const taxonomyTid = entity.getIn(['tid', 0, 'value']);

  return (
    <div className="ActivityTeaser">
      <div className="ActivityTeaser__content">
        {entity.getIn(['field_media_image', 0]) && (
          <div className="ActivityTeaser__content__image">
            <Image
              lazyload={false}
              src={{
                [SCREEN_MOBILE]: entity.getIn(['field_hero_image', 0, 'styles', 'ratio_1_1_xs']),
                [SCREEN_TABLET]: entity.getIn(['field_hero_image', 0, 'styles', 'ratio_1_1_xs']),
                [SCREEN_NORMAL]: entity.getIn(['field_hero_image', 0, 'styles', 'ratio_3_2_sm']),
              }}
              alt={entity.getIn(['field_hero_image', 0, 'alt'], '')}
            />
          </div>
        )}
        <InformationOverlay
          overlayKey="Overlay_NodeResult"
          buttonTitle={name}
          buttonIcon="arrow-right"
          buttonClassName="ActivityTeaser__content__button"
        >
          <Taxonomy
            id={taxonomyTid}
            entity={entity}
            viewMode="overlay"
          />
        </InformationOverlay>
      </div>
    </div>
  );
};

export default ActivityTeaser;
